import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EntryProtocolAttachmentDelete, GetAllEntryProtocolAttachments, resetEntryProtocolAttachmentDeleteStatus, resetEPAttCreationRequest, resetEPAttUpdateRequest, setAttachtoUpdate, setGetAllEPAttPage } from "../../protocol/entry/slice"
import { PaperClipIcon } from "../../../ui/icons/PaperclipIcon"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { Pagination } from "../../../ui/organisms/pagination"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { EntryProtocolAttachmentDTO } from "../../protocol/entry/dataService/dto"
import Button from "../../../ui/molecules/button"
import { Alert } from "../../../ui/organisms/alert"
import { PopupEntryEdit } from "../popup/entryEdit"

export function AttachmentsListEntry() {
    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [attToDelete, setAttToDelete] = useState<EntryProtocolAttachmentDTO | undefined>(undefined)
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [showSuccessDelete, setShowSuccessDelete] = useState<boolean>(false)
    const [showSuccessEdit, setShowSuccessEdit] = useState<boolean>(false)
    const [showSuccessCreate, setShowSuccessCreate] = useState<boolean>(false)

    useEffect(() => {
        dispatch(GetAllEntryProtocolAttachments({ itemsPerPage: 30, page: entryProtocolState.getAllEntryProtocolAttachmentsFilters.page, order: false }))
    }, [entryProtocolState.getAllEntryProtocolAttachmentsFilters])

    useEffect(() => {
        if (entryProtocolState.entryProtocolAttachmentCreationStatus == 'successfully') {
            dispatch(resetEPAttCreationRequest())
            setShowSuccessCreate(true)
            setTimeout(() => {
                setShowSuccessCreate(false)
            }, 2500);
            dispatch(GetAllEntryProtocolAttachments({ itemsPerPage: 30, page: entryProtocolState.getAllEntryProtocolAttachmentsFilters.page, order: false }))
        }
    }, [entryProtocolState.entryProtocolAttachmentCreationStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolAttachmentUpdateStatus == 'successfully') {
            dispatch(resetEPAttUpdateRequest())
            setShowSuccessEdit(true)
            setTimeout(() => {
                setShowSuccessEdit(false)
            }, 2500);
            setShowPopup(false)
            dispatch(GetAllEntryProtocolAttachments({ itemsPerPage: 30, page: entryProtocolState.getAllEntryProtocolAttachmentsFilters.page, order: false }))
        }
    }, [entryProtocolState.entryProtocolAttachmentUpdateStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolAttachmentDeleteStatus === 'successfully') {
            setShowSuccessDelete(true)
            setTimeout(() => {
                setShowSuccessDelete(false)
            }, 2500);
            dispatch(resetEntryProtocolAttachmentDeleteStatus())
            setAttToDelete(undefined)
            dispatch(GetAllEntryProtocolAttachments({ itemsPerPage: 30, page: entryProtocolState.getAllEntryProtocolAttachmentsFilters.page, order: false }))
        }
    }, [entryProtocolState.entryProtocolAttachmentDeleteStatus])
    

    return (
        <div className="w-[100%] flex flex-col gap-[16px] filter bg-brandPrimary-200" style={{ flex: 0.7, padding: '0px 24px 24px 24px', borderTopRightRadius: '20px' }}>
            <div className="w-[100%]">
            {
                (showSuccessDelete) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontWeight: '700', display: 'block' }}>
                        Allegato eliminato correttamente.
                    </span>
                </div>
            }
            {
                (showSuccessCreate) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontWeight: '700', display: 'block' }}>
                        Allegato creato correttamente.
                    </span>
                </div>
            }
            {
                (showSuccessEdit) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontWeight: '700', display: 'block' }}>
                        Allegato modificato correttamente.
                    </span>
                </div>
            }
                <div style={{ padding: '24px 0' }}>
                    <table id="users-table" className="w-[100%]">
                        <thead className="h-[52px] uppercase">
                            <tr>
                                <th style={{ borderTopLeftRadius: '8px', width: '5%' }}></th>
                                <th>Descrizione</th>
                                <th>Codifica</th>
                                <th>Presente in cartella aziendale</th>
                                <th>Delibera</th>
                                <th style={{ borderTopRightRadius: '8px', width: '5%' }}></th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                entryProtocolState.getAllEntryProtocolAttachmentsResponse?.data.map((att, index) =>
                                    <tr
                                        key={index}
                                        style={{
                                            color: '#4D797F',
                                            background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                        }}
                                    >
                                        <td className="w-[30px]">
                                            <PaperClipIcon />
                                        </td>
                                        <td>{att.description}</td>
                                        <td>{att.coding}</td>
                                        <td>{att.status ? 'SI' : 'NO'}</td>
                                        <td>{`Delibera`}</td>
                                        <td className="w-[20px]">
                                            <div className="flex justify-content-between align-items-center">
                                                <button onClick={() => {
                                                    setShowPopup(true)
                                                    dispatch(setAttachtoUpdate(att))
                                                }}>
                                                    <EditIcon color={"Orange"} size={18} />
                                                </button>

                                                <div className="pl-2 flex align-items-center">
                                                    <button onClick={() => {
                                                        setAttToDelete(att)
                                                        setShowAlert(true)
                                                    }}>
                                                        <TrashIcon color={"Orange"} size={0} />
                                                    </button>
                                                </div>

                                            </div>
                                        </td>


                                    </tr>
                                )}
                        </tbody>
                    </table>
                    <Pagination
                        numbResults={entryProtocolState.getAllEntryProtocolAttachmentsResponse?.total || 0}
                        pages={entryProtocolState.getAllEntryProtocolAttachmentsResponse?.totalPage || 1}
                        currentPage={entryProtocolState.getAllEntryProtocolAttachmentsFilters.page || 0}
                        setPage={
                            (page) => {
                                dispatch(setGetAllEPAttPage(page))
                            }
                        }

                    />
                </div>
            </div>
            {
                (showAlert && attToDelete) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div>
                                    Sei sicuro di voler eliminare l'allegato?
                                </div>
                                <div className="mt-3 font-bold">
                                    {`${attToDelete.description} - [${attToDelete.coding}]`}
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => dispatch(EntryProtocolAttachmentDelete(attToDelete.id!))}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
            {
                showPopup && (
                    <PopupForm title="Modifica Allegato" close={() => setShowPopup(false)}>
                        <PopupEntryEdit close={() => setShowPopup(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}